module.exports = __webpack_public_path__ + "static/phone-receipts-b87f9850a8311e27d5dda86921e4b9f3.png";